// new support just only png,jpg,jpeg
export const IMAGE_TYPE_WHITE_LISTS = ["image/png", "image/jpeg"];
export const IMAGE_TYPE_WHITE_LISTS_REGEX = new RegExp(/\.(jpe?g|png)$/, "i");
export const IMAGE_TYPE_WHITE_LISTS_REGEX_BASE64 = new RegExp('data:image/(jpe?g|png)([a-zA-Z]*);base64,([^"]*)');
export const ERROR_MESSAGE_UPLOAD_IMAGE = "uploadImage.type.error";
